// src/RouteSwitch.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom"; // Removed Link
// Removed App import as it's not used in this component directly
import Home from "./pages/Home";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import News from "./pages/News";
import Workshops from "./pages/Workshops";
import About from "./pages/About";
import Navbar from "./components/Navbar";
import DogPortrait from "./pages/DogPortrait";

import CategoryPage from "./pages/CategoryPage";

const RouteSwitch = () => {
  return (
    <div>
      <BrowserRouter>
        <Navbar /> {/* Your Navbar component */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/news" element={<News />} />
          <Route path="/about" element={<About />} />
          <Route path="/dog-portrait" element={<DogPortrait />} />
          <Route path="/workshops" element={<Workshops />} />
          {/* New Dynamic Route for all Painting Categories */}
          <Route path="/category/:categoryName" element={<CategoryPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default RouteSwitch;
